import React from "react";
import _ from 'lodash';
export const ConnectToZoom = ({
                                  completedIdxs,
                                  currentDomain,
                                  token,
                                  username,
                                  redirectUrl,
                                  suggestedEmail,
                                  suggestedToken,
                                  zoomError,
                                  renderErrorMessage
                              }) => {
    return <div className={"step flexRowContainer"} id={"zoom"}>
        <h3 className={"mb10"}>
            Let's connect to Zoom
        </h3>
        <span>
                        We rely on Zoom for meetings. Each user will need to have a Zoom account before entering
                        qube.<br/><br/>

                        If you're not using Zoom yet, get started for free <a className={"setupLink"}
                                                                              href="https://zoom.us/signup"
                                                                              target="_blank" rel="noreferrer">here</a>.<br/><br/><b>You must be an
                        administrator to integrate with Zoom.<br/>
                        "Add to Zoom" within Zoom’s marketplace will not work - you must click the "Add to Zoom" button below.
                        </b><br/><br/>
                        </span>
        <div className={"flexColumnContainer flexFill mt30"}>
            <div className={"flexFill"}/>
            {_.indexOf(completedIdxs, 3) < 0 ?
                <a href={"https://zoom.us/oauth/authorize?response_type=code&client_id=" + process.env.VITE_ZOOM_CLIENT_ID + "&redirect_uri=https://" + currentDomain + "/zoom/add_to_workspace?token=" + token + "&email=" + username}
                   rel="noopener noreferrer"><img
                    src="https://marketplacecontent.zoom.us/zoom_marketplace/img/add_to_zoom.png"
                    height="32" alt="Add to ZOOM"/></a> :
                <b className={"signupSuccessColor"}><i className={"fas fa-check"}/> Zoom is already
                    connected</b>}
        </div>
        {zoomError && <div className={'flexColumnContainer text-danger flexAlignCenter mt15'}>
            <span className={"fa fa-warning pr5"}/>
            <span><strong>This zoom account is already linked to an existing qube workspace. You can view that workspace by clicking <a
                href={redirectUrl + "/setup?email=" + suggestedEmail + "&token=" + suggestedToken}>here</a> </strong></span>
        </div>}
        {renderErrorMessage()}
    </div>
};